import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';
import useSessionTimeout from '../../Reusables/VisualAndAccord/Hooks/useSessionTimeout';

const getCookie = (name) => {
  if (typeof document === 'undefined') return null;
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
  return null;
};

const PrivateRoute = ({ children }) => {
  const [expire, setExpire] = useState(false);
  const user = useSelector((state) => state.userReducer);
  const hasToken = user.token || localStorage.getItem('jwt_token') || getCookie('jwt_token');

  useSessionTimeout(() => setExpire(true));

  if (!hasToken || expire) {
    return <Navigate to="/" replace />;
  }


  return <>{children}</>;
};

export default PrivateRoute;
